/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrdfConnectionConfigUpdate } from '../../models/grdf-connection-config-update';

export interface UpdateGrdfConnectionConfiguration$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected GRDF connection configuration
 */
  grdfUid: string;
  
    /**
     * The GRDF connection update object
     */
    body?: GrdfConnectionConfigUpdate
}

export function updateGrdfConnectionConfiguration(http: HttpClient, rootUrl: string, params: UpdateGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateGrdfConnectionConfiguration.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('grdfUid', params.grdfUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateGrdfConnectionConfiguration.PATH = '/stations/{uid}/grdf/{grdfUid}';
